import { FC } from 'react';
import { Card } from '@app/shared/components/card/Card';
import { FormValue } from '@app/shared/components/form-controls/form-value/FormValue';
import { useAppSelector } from '@app/core/hooks/redux-hooks';
import { Country } from '@app/shared/models/contracts/enums/shared-enums';
import { useLocale } from '@app/core/hooks/useLocale';

const TaxJurisdictions: FC = (): JSX.Element => {
  const { mainTaxJurisdiction, secondaryTaxJurisdiction } = useAppSelector(
    (state) => state.project.projectDraft.details
  );
  const { l } = useLocale();

  return (
    <Card>
      <h3>{l('_TaxJurisdictions')}</h3>
      <div className="form-row form-row--three-column">
        <div className="form-row__column">
          <FormValue
            label={l('_MainTaxJurisdiction')}
            value={mainTaxJurisdiction ? Country[mainTaxJurisdiction] : ''}
            isGapless
          />
        </div>
        <div className="form-row__column">
          <FormValue
            label={l('_SecondaryTaxJurisdiction')}
            value={secondaryTaxJurisdiction ? Country[secondaryTaxJurisdiction] : ''}
            isGapless
          />
        </div>
        <div className="form-row__column" />
      </div>
    </Card>
  );
};

export default TaxJurisdictions;
